<template>
<div>
  <div class="order-item">
    <div class="order-item-basics">
      <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" v-bind:class="'order-item-more'" v-bind:svg-inline="''" @click="showDetail" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zM5.867 9.533a1.467 1.467 0 100 2.934 1.467 1.467 0 000-2.934zm5.133 0a1.467 1.467 0 100 2.934 1.467 1.467 0 000-2.934zm5.133 0a1.467 1.467 0 100 2.934 1.467 1.467 0 000-2.934z" fill="#B6BBC3" fill-rule="evenodd"/></svg>

      <div class='order-item-image'>
        <img v-if="image" class="item-img" :src="imageSrc(image)" title="" />
        <div class="order-item-badge" v-if="product.count >= 2">
          <span class='order-item-badge-number'>{{product.count}}</span>
        </div>
      </div>
      <span class='order-item-product-name'>{{productName}}</span>
      <!-- <h3>{{product.snapshot.sku}}</h3> -->
      <span class="order-item-price">{{product.snapshot.price[0].brutto * product.count|formatNumber}}</span>
    </div>
  </div>

  <modal v-if="this.showingDetail" @close="closeDetail()" class='allow-overflow'>
    <div class="order-item-modal" slot="body">
      <div class='image-wrap'>
        <img v-if="image" class="item-img" :src="imageSrc(image)" title="" />
      </div>

      <div class="order-item-info">
        <span class='order-item-product-name'>{{productName}}</span>
        <div class='order-item-props-wrap' v-if="product.snapshot.attrModel">
          <div class='order-item-props' v-for="paramFiled in product.snapshot.attrModel.itemFields">
            <div class="order-item-prop-wrap">
              <div class="order-item-prop">{{paramFiled.name[lang]}}:</div>
              <span class="order-item-prop-value">{{product.snapshot.attribs[paramFiled.field][lang]}}</span>
            </div>
          </div>
        </div>
        <!-- <h3>{{product.snapshot.sku}}</h3> -->

        <div class='order-item-amount-price'>
          <div class='order-item-count-wrap' :class="{'disabled': addStatus == 'checking'}">
            <a href="javascript:" v-on:click="substract(product)" class="amount-btn">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M6.03 13h11.94v-2H6.03z"/></svg>
            </a>
            <span class="order-item-count">{{product.count}}</span>
            <a href="javascript:" v-on:click="add(product)" class="amount-btn" :class="{'disabled': addStatus != 'available' }">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13 5.5V11h4.97v2H13v5.5h-2V13H6.03v-2H11V5.5h2z" fill="#2A313C" fill-rule="nonzero"/></svg>
            </a>
          </div>

          <span class="order-item-price">{{product.snapshot.price[0].brutto * product.count|formatPrice}}</span>
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class='order-item-modal-footer'>
      <a href="javascript:" v-on:click='closeDetail(product)' class='pfm-button confirm icononly'>
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
      </a>
      <a href="javascript:" v-on:click="remove(product)" class="pfm-button inline icon danger">
        <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#90949A" fill-rule="nonzero"><path d="M11.613 11.656h1.21v9.68h-1.21zM14.033 11.656h1.21v9.68h-1.21zM16.453 11.656h1.21v9.68h-1.21zM6.5 7.139h16.276v2.097H6.5z"/><path d="M16.548 7.655v-1.21c0-.363-.288-.748-.65-.748h-2.42c-.364 0-.64.385-.64.748v1.21h-1.293v-1.21c0-.968.964-2.151 1.932-2.151h2.42c.968 0 2.051 1.183 2.051 2.15v1.21h-1.4zM8.235 23.26L7.037 7.851l2.105.035 1.256 15.606h8.434l1.112-15.606 2.295-.035-1.198 15.41a2.81 2.81 0 01-2.773 2.584h-7.26a2.76 2.76 0 01-1.878-.758 2.84 2.84 0 01-.895-1.829z"/></g></svg>
        <span>Odebrat</span>
      </a>
        </div>
    </div>
  </modal>

</div>
</template>

<script>
import Cart from '@/cart'
import Langs from '../../langs'

import Modal from '../ModalPanel'
// import Dialog from '../../dialog'

export default {
  name: 'product-item',
  props: ['product'],
  components: {
    Modal
  },
  data() {
    return {
      showingDetail: false,
      lang: Cart.lang,
      image: null,
      imagesBucket: process.env.VUE_APP_GCS_BUCKET_IMAGES_COMMERCE,
      addStatus: 'available'
    }
  },
  computed: {
    productName() {
      if (this.product.snapshot.desc) {
        return this.product.snapshot.desc.title[Cart.lang]
      } else {
        return '...'
      }
    },
    available() {
      return this.$store.getters['productAvailable/isAvailable'](this.product.snapshot.id)
    },
  },
  created() {
    console.log('Product', this.product)
    let image = {}
    if (this.product.snapshot.config && this.product.snapshot.config.images) {
      image = this.product.snapshot.config.images.find(img => img.variant)
      if (!image) {
        image = this.product.snapshot.config.images.find(img => img.main)
        console.log('Using main', image)
      }
      if (!image && this.product.snapshot.config.images.length > 0) {
        image = this.product.snapshot.config.images[0]
        console.log('Using first', image)
      }
    }
    if (!image) {
      image = {}
    }
    console.log(this.product)
    console.log('Images', image, (this.product.snapshot.config) ? this.product.snapshot.config.images : 'No images')
    this.image = image

  },
  methods: {
    imageSrc(image) {
      let imageId = image.imageId ? image.imageId : image.name // legacy
      let url = `${process.env.VUE_APP_CDN_STATIC}/shops/${Cart.shopId}/images/${imageId}`
      let params = `$w_900,q_80,x_3`
      return `${url}${params}`
    },
    showDetail() {
      console.log('Showing detail')
      this.showingDetail = true
    },
    add(product) {
      this.addStatus = 'checking'
      Cart.setCount(this.product.snapshot.id, product.count + 1)
      .then(res => {
        if (!res.available) {
          this.addStatus = 'notAvailable'
        } else {
          this.addStatus = 'available'
        }
      })
    },
    substract(product) {
      if (product.count > 0) {
        Cart.setCount(this.product.snapshot.id, product.count - 1)
      }
    },
    remove(product) {
      // Dialog.show({
      //   type: 'question',
      //   message: Langs.get('product-question-delete'),
      //   buttons: [{text: Langs.get('option-yes'), action: this.deleteProductY}, {text: Langs.get('option-no'), action: this.deleteProductN, primary: true}],
      //   payload: product
      // })
      this.showingDetail = false
      this.$emit('remove');
    },
    // deleteProductY(data) {
    //   this.showingDetail = false
    //   this.$emit('remove');
    //   Dialog.hide()
    // },
    // deleteProductN(data) {
    //   Dialog.hide()
    // },
    closeDetail() {
      this.showingDetail = false
    }
  }
}
</script>

<style scoped lang='less'>
@import '../../variables.less';

.order-item {

    .order-item-basics {
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0;

        .order-item-more {
            width: 22px;
            height: 22px;
            display: block;
            box-sizing: content-box;
            padding-right: 16px;
            cursor: pointer;
        }

        .order-item-image {
            position: relative;
            margin-right: 18px;

            img.item-img {
                width: 60px;
                height: 60px;
                border-radius: 50%;
                display: block;
            }

            .order-item-badge {
                position: absolute;
                top: -6px;
                right: -4px;
                background-color: #ffffff;
                color: @pfm-cart-color-text-light;
                width: 22px;
                height: 22px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                box-shadow: 0 2px 5px 0 rgba(0,0,0,0.13);

                span.order-item-badge-number {
                    font-weight: 500;
                }
            }
        }

        span {
            display: block;

            &.order-item-product-name {
                flex: 1;
                font-weight: 700;
            }

            &.order-item-price {
                font-weight: 700;
                color: @pfm-cart-color-text-light;
            }
        }
    }
}

.order-item-modal {
    position: relative;
    padding-top: 50px;

    .image-wrap {
        position: absolute;
        top: -50px;
        right: 0;
        left: 0;
        z-index: 100;

        .item-img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            border: 4px solid #fff;
            margin: 0 auto;
            display: block;
        }
    }

    .order-item-info {
        .order-item-product-name {
            font-size: 1.6rem;
            font-weight: 700;
            display: block;
            text-align: center;
            padding: 10px 0 20px;
        }

        .order-item-props-wrap {
          min-height: 50px;
        }

        .order-item-amount-price {
          display: flex;
          flex-flow: row;
          justify-content: space-between;
          align-items: center;
          width: 100%;

            .order-item-count-wrap {
                height: 40px;
                border: 2px solid @pfm-cart-color-border;
                border-radius: 20px;
                width: auto;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                .order-item-count {
                  font-weight: 700;
                  font-size: 1.25rem
                }

                .amount-btn {
                  padding: 10px;
                  display: flex;
                }
            }

            .order-item-price {
              font-size: 1.6rem;
              color: @pfm-cart-text-body;
              font-weight: 500;
            }

        }
    }

}

.order-item-modal-footer {
  a.pfm-button.confirm {
    margin-top: 20px !important;
  }
}
</style>
